import styled, { css } from 'styled-components';
import { ShimmingCard } from '@getgrover/ui';

const { Content } = ShimmingCard.defaultComponents;

export const Headline = styled.h6`
    ${(props) => css(props.theme.typography.SmallCapsHeadline)}
    color: ${(props) => props.theme.colors['Level 4']};
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;

    margin: 0;
    padding-top: 4px;
    padding-bottom: 12px;

    cursor: default;
`;

export const Container = styled(ShimmingCard)`
    max-width: 100%;
    width: 347px;
`;

export const CardContent = styled(Content)`
    display: flex;
    flex-direction: column;
`;
